/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".marketing[_ngcontent-%COMP%]   .col-lg-4[_ngcontent-%COMP%]{margin-bottom:1.5rem;text-align:center}.marketing[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-weight:400}.marketing[_ngcontent-%COMP%]   .col-lg-4[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-right:.75rem;margin-left:.75rem}.bd-placeholder-img[_ngcontent-%COMP%]{font-size:1.125rem;text-anchor:middle}@media (min-width:768px){.bd-placeholder-img-lg[_ngcontent-%COMP%]{font-size:3.5rem}}"];
export { styles as styles };

